import { create } from 'zustand';
import { isValidLegalPersonNumber, isValidNaturalPersonNumber } from '../../utils/nifValidation';
export const useFormValidationStore = create((set, get) => ({
    errors: {},
    validateField: (variableName, value, config) => {
        var _a, _b, _c, _d, _e, _f;
        let error = null;
        switch (config.type) {
            case 'email':
                // formato RFC-822 simplificado
                if (typeof value !== 'string' || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                    error = (_a = config.message) !== null && _a !== void 0 ? _a : 'PDDForm.Validations.incorrectFormat';
                }
                break;
            case 'phone':
                // Debe tener exactamente 9 dígitos (solo números)
                if (typeof value !== 'string' || !/^[0-9]{9}$/.test(value)) {
                    error = (_b = config.message) !== null && _b !== void 0 ? _b : 'PDDForm.Validations.incorrectFormat';
                }
                break;
            case 'cif-nif':
                // Debe tener exactamente 9 dígitos (solo números)
                if (!isValidLegalPersonNumber(value) && !isValidNaturalPersonNumber(value)) {
                    error = (_c = config.message) !== null && _c !== void 0 ? _c : 'PDDForm.Validations.incorrectFormat';
                }
                break;
            case 'custom-regex':
                let pattern;
                if (typeof config.regex === 'string') {
                    pattern = new RegExp(config.regex);
                }
                else if (config.regex instanceof RegExp) {
                    pattern = config.regex;
                }
                else {
                    // no hay regex válido → marcamos error
                    error = config.message;
                    break;
                }
                if (!pattern.test(String(value))) {
                    error = (_d = config.message) !== null && _d !== void 0 ? _d : 'PDDForm.Validations.incorrectFormat';
                }
                break;
            case 'length':
                if (typeof config.length !== 'number') {
                    error = 'Configuración de longitud inválida';
                    break;
                }
                const max = config.length;
                const val = value;
                if (value === undefined || value === null || (typeof value === 'string' && val.length === 0) || (Array.isArray(value) && val.length === 0)) {
                    error = (_e = config.message) !== null && _e !== void 0 ? _e : 'PDDForm.Validations.mandatoryField';
                    break;
                }
                if (val.length > max) {
                    error = (_f = config.message) !== null && _f !== void 0 ? _f : `PDDForm.Validations.maxLength`;
                }
                break;
        }
        set((state) => ({
            errors: Object.assign(Object.assign({}, state.errors), { [variableName]: error }),
        }));
    },
    clearError: (variableName) => {
        set((state) => ({
            errors: Object.assign(Object.assign({}, state.errors), { [variableName]: null }),
        }));
    },
    isSectionValid: (questions) => {
        const { errors } = get();
        return questions.every((qv) => {
            const err = errors[qv.variableName];
            // err es string (mensaje) → false,
            // err es null | undefined → true
            return !err;
        });
    },
}));
